import React from "react";

const Cancel = () => {
    return ( 
        <h1>Sorry to see you cancelled your Stripe payment</h1>
     );
}
 
export default Cancel;